module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 optGroups.forEach(function(optGroup, i) { 
__p+='\n    ';
 if (optGroup.label) { 
__p+='\n        <h3 ';
 if (i > 0) { 
__p+='class="u-spaceTop"';
 } 
__p+='>\n            '+
((__t=( optGroup.label ))==null?'':_.escape(__t))+
'\n        </h3>\n    ';
 } 
__p+='\n    <div class="checkboxList">\n        ';
 optGroup.options.forEach(function(option) { 
__p+='\n            <div class="checkboxList__listItem">\n                <label\n                    class="checkboxList__label '+
((__t=( option.selected ? 'is-active' : '' ))==null?'':_.escape(__t))+
'"\n                    for="'+
((__t=(option.id))==null?'':_.escape(__t))+
'">'+
((__t=( option.name ))==null?'':_.escape(__t))+
'</label>\n                <input\n                    type="checkbox"\n                    id="'+
((__t=(option.id ))==null?'':_.escape(__t))+
'"\n                    name="'+
((__t=(option.id ))==null?'':_.escape(__t))+
'"\n                    class="is-hidden"\n                    value="'+
((__t=(option.value))==null?'':_.escape(__t))+
'"\n                    '+
((__t=( option.selected ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n            </div>\n        ';
 }); 
__p+='\n    </div>\n';
 }); 
__p+='\n';
}
return __p;
};
